"use client";
import { Button, Stack } from "@chakra-ui/react";
import DataCenterMap from "@/components/dataCenterMap";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import { scrollToElement } from "@/utils/scrollToElement";

const MapComponent = () => {
  return (
    <Stack w={"100%"}>
      <DataCenterMap asLink={false} />
      <Button
        variant={BUTTON_VARIANTS.IDEAL}
        onClick={() => scrollToElement("dataCenters", 140)}
        alignSelf={"center"}
      >
        Click to explore our Data Centers
      </Button>
    </Stack>
  );
};

export default MapComponent;
